import React, { useEffect, useState } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { ROUTES } from "../../routes/routerConfig";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/ui/Button";
import { useSelector } from "react-redux";
type Props = {
  setNextStep: (step: string) => void;
};
const ThankYouPage = ({ setNextStep }: Props) => {
  const [errorMessage, setErrorMessage] = useState(""); // Initialize state for errorMessage message
  const [color, setColor] = useState("gray"); // Default text color
  const navigate = useNavigate();
  const rawSignupOnboardApi = useSelector(
    (state: any) => state.keyRegistrar.signupOnboardApi
  );

  useEffect(() => {
    if (rawSignupOnboardApi.length == 0) {
      setErrorMessage(
        "Your CIF number has been successfully registered. You can now log in to the customer portal using your CIF/Email/Mobile number."
      );
      //setColor("red");
      // Perform any logic based on the updated signupOnboardApi
    } else {
      setErrorMessage(
        "Your CIF number has been successfully registered. You can now log in to the customer portal using your CIF/Email/Mobile number."
      );
      setColor("gary");
    }
  }, [rawSignupOnboardApi]); // Dependency array with signupOnboardApi
  const handleClick = () => {
    window.location.href = "/login";
    // if (color == "red") {
    //   setNextStep(ROUTES?.Login?.enterPassword?.path);
    // } else {
    //   window.location.href = "/login";
    // }
  };

  return (
    <Container
      maxWidth="sm"
      style={{
        textAlign: "center",
        marginTop: "50px",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      <Typography variant="h4" gutterBottom color={color}>
        Thank You!
      </Typography>
      <Typography variant="body1" color={color} gutterBottom>
        {errorMessage}
      </Typography>
      <Box mt={3}>
        <PrimaryButton
          variant="contained"
          onClick={handleClick}
          style={{ padding: "10px 20px" }}
        >
          Continue
        </PrimaryButton>
      </Box>
    </Container>
  );
};

export default ThankYouPage;
